import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloCity } from '@/models/alo/AloCity'

export default {  
  findCity(cp: string): AxiosPromise<AlrContainer<Array<AloCity>>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/city/findCity`, 
      method: 'GET',
      params : {cp},
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<AloCity>>
      }]
    })
  }
}